import { render, staticRenderFns } from "./WpInstall.vue?vue&type=template&id=5c6c8008&"
import script from "./WpInstall.vue?vue&type=script&lang=js&"
export * from "./WpInstall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6c8008')) {
      api.createRecord('5c6c8008', component.options)
    } else {
      api.reload('5c6c8008', component.options)
    }
    module.hot.accept("./WpInstall.vue?vue&type=template&id=5c6c8008&", function () {
      api.rerender('5c6c8008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/WpInstall.vue"
export default component.exports